import { tokens } from '@fluentui/react-components';
import { ReactNode } from 'react';
import { useChallengeItemStyles } from './FatSideBarAccent.styles';

export interface FatSideBarAccentProps {
  name?: string
  accentColor?: string
  icon: ReactNode

}

const FatSideBarAccent: React.FC<FatSideBarAccentProps> = ({
  accentColor = tokens.colorNeutralBackground1,
  icon,
  name,
}: FatSideBarAccentProps) => {
  const styles = useChallengeItemStyles();
  return (
    <div
      data-testid="left"
      className={styles.fatSideBarAccent}
      style={{
        backgroundColor: accentColor,
      }}
    >
      <div className={styles.iconContainer} aria-label={`Icon for ${name}`} role="img">
        <div aria-hidden="true" className={styles.backDrop}></div>
        {icon}
      </div>
    </div>
  );
};

export default FatSideBarAccent;
